import ElstrIo from "../../ElstrIo";

export default class ElstrLanguageService {
  static async getAllMessages(): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc<{}, any>("language", "getAllMessages", {});
    } catch (e) {
      throw e;
    }
  }

  static async getLocale() {
    try {
      return await ElstrIo.requestJsonRpc<{}, any>("language", "getLocale", {});
    } catch (e) {
      throw e;
    }
  }
}
